export const BREAKPOINTS = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: Infinity,
};

export const SIZE_DEFAULT = 'default';
export const SIZE_XS = 'xs';
export const SIZE_SM = 'sm';
export const SIZE_MD = 'md';
export const SIZE_LG = 'lg';
export const SIZE_XL = 'xl';

export const SIZES = [
  SIZE_DEFAULT,
  SIZE_XS,
  SIZE_SM,
  SIZE_MD,
  SIZE_LG,
  SIZE_XL,
];

export const COLOR_AUTO = 'auto';
export const COLOR_LIGHT = 'light';
export const COLOR_PRIMARY = 'primary';
export const COLOR_PRIMARY_LIGHT = 'primary-light';
export const COLOR_SECONDARY = 'secondary';
export const COLOR_SECONDARY_LIGHT = 'secondary-light';
export const COLOR_SUCCESS = 'success';
export const COLOR_SUCCESS_LIGHT = 'success-light';
export const COLOR_WARNING = 'warning';
export const COLOR_WARNING_DARK = 'warning-dark';
export const COLOR_WARNING_LIGHT = 'warning-light';
export const COLOR_DANGER = 'danger';
export const COLOR_DANGER_LIGHT = 'danger-light';
export const COLOR_INFO = 'info';
export const COLOR_MUTED = 'muted';
export const COLOR_WHITE = 'white';
export const COLOR_GRAY_100 = 'gray-100';
export const COLOR_GRAY_200 = 'gray-200';
export const COLOR_GRAY_300 = 'gray-300';
export const COLOR_GRAY_500 = 'gray-500';
export const COLOR_GRAY_600 = 'gray-600';
export const COLOR_GRAY_900 = 'gray-900';
export const COLOR_LINK = 'link';
export const COLOR_CALM = 'calm';
export const COLOR_CALM_LIGHT = 'calm-light';
export const COLOR_YELLOW = 'yellow';
export const COLOR_TRANSPARENT = 'transparent';

export const COLORS = [
  COLOR_AUTO,
  COLOR_CALM,
  COLOR_CALM_LIGHT,
  COLOR_LIGHT,
  COLOR_PRIMARY,
  COLOR_PRIMARY_LIGHT,
  COLOR_SECONDARY,
  COLOR_SECONDARY_LIGHT,
  COLOR_SUCCESS,
  COLOR_SUCCESS_LIGHT,
  COLOR_WARNING,
  COLOR_WARNING_DARK,
  COLOR_WARNING_LIGHT,
  COLOR_DANGER,
  COLOR_DANGER_LIGHT,
  COLOR_INFO,
  COLOR_MUTED,
  COLOR_WHITE,
  COLOR_GRAY_100,
  COLOR_GRAY_200,
  COLOR_GRAY_300,
  COLOR_GRAY_500,
  COLOR_GRAY_600,
  COLOR_GRAY_900,
  COLOR_LINK,
  COLOR_YELLOW,
  COLOR_TRANSPARENT,
];

export const LOADING_LAZY = 'lazy';
export const LOADING_EAGER = 'eager';
export const LOADING_AUTO = 'auto';

export const LOADING_TYPES = [
  LOADING_LAZY,
  LOADING_EAGER,
  LOADING_AUTO,
];

export const STATE_FOCUS = 'focus';
export const STATE_ACTIVE = 'active';
export const STATE_DISABLED = 'disabled';

export const STATES = [
  STATE_FOCUS,
  STATE_ACTIVE,
  STATE_DISABLED,
];

export const ALIGNMENT_TOP = 'top';
export const ALIGNMENT_MIDDLE = 'middle';
export const ALIGNMENT_BOTTOM = 'bottom';

export const ALIGNMENT_START = 'start';
export const ALIGNMENT_CENTER = 'center';
export const ALIGNMENT_END = 'end';

export const ALIGNMENTS = [
  ALIGNMENT_TOP,
  ALIGNMENT_MIDDLE,
  ALIGNMENT_BOTTOM,
  ALIGNMENT_START,
  ALIGNMENT_CENTER,
  ALIGNMENT_END,
];

export const DIRECTION_ABOVE = 'above';
export const DIRECTION_TOP = 'top';
export const DIRECTION_BELOW = 'below';
export const DIRECTION_BOTTOM = 'bottom';

export const DIRECTIONS = [
  DIRECTION_ABOVE,
  DIRECTION_TOP,
  DIRECTION_BELOW,
  DIRECTION_BOTTOM,
];

export const VALIDATION_TYPE_INVALID = 'invalid';
export const VALIDATION_TYPE_VALID = 'valid';
export const VALIDATION_TYPES = [
  VALIDATION_TYPE_INVALID,
  VALIDATION_TYPE_VALID,
];

export const PLACEMENT_TOP = 'top';
export const PLACEMENT_BOTTOM = 'bottom';
export const PLACEMENT_LEFT = 'left';
export const PLACEMENT_RIGHT = 'right';
export const PLACEMENT_AUTO = 'auto';
export const PLACEMENT_CENTER = 'center';

export const PLACEMENTS = [
  PLACEMENT_TOP,
  PLACEMENT_BOTTOM,
  PLACEMENT_LEFT,
  PLACEMENT_RIGHT,
  PLACEMENT_AUTO,
];

export const ANCHOR_TARGET_SELF = '_self';
export const ANCHOR_TARGET_BLANK = '_blank';
export const ANCHOR_TARGET_PARENT = '_parent';
export const ANCHOR_TARGET_TOP = '_top';

export const ANCHOR_TARGETS = [
  ANCHOR_TARGET_SELF,
  ANCHOR_TARGET_BLANK,
  ANCHOR_TARGET_PARENT,
  ANCHOR_TARGET_TOP,
];

export const ICON_SHAPE_ROUNDED_SQUARE = 'rounded-square';
export const ICON_SHAPE_CIRCLE = 'circle';

export const ICON_SHAPES = [
  ICON_SHAPE_ROUNDED_SQUARE,
  ICON_SHAPE_CIRCLE,
];
